import { component } from '../../../../decorators';

import { OPENER_MIXIN } from '../../../../mixins/opener.mixin';

import QUERY_MIXIN from '../query-mixin';

import Checkbox from '../../../../components/common/checkbox/checkbox.vue';

@component({
   components: { Checkbox },
   mixins: [ OPENER_MIXIN, QUERY_MIXIN ]
})
export default class ListOfFields {
}
